import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`All `}<a parentName="p" {...{
        "href": "/react-sim/api#common-control-props"
      }}>{`Common control props`}</a>{` properties, plus:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`maxValue`}</strong><br />{`number, optional, default 100`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The value corresponding to the end of the range.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`minValue`}</strong><br />{`number, optional, default 0`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The value corresponding to the beginning of the range.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`name`}</strong><br />{`string, optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The name of the control. If not specified, label is used.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`shouldDisplayLabel`}</strong><br />{`boolean, default true`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whether the label should be displayed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`shouldDisplayMaxValue`}</strong><br />{`boolean, default true`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whether the maximum value should be displayed to the right of the range.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`shouldDisplayMinValue`}</strong><br />{`boolean, default true`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whether the minimum value should be displayed to the left of the range.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`shouldDisplayValue`}</strong><br />{`boolean, default true`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whether the value should be displayed next to the label.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`shouldDisplaySlider`}</strong><br />{`boolean, default true`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whether the slider should be displayed. If the slider is not displayed, the min and max values are also hidden.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`step`}</strong><br />{`number, optional, default 1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The amount by which the value will be incremeneted or decremented when moving the range cursor.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      